<template>
  <div class="state8">
    <lib
      fixed-course-serialnumber="0301"
      fixed-course-name="专科微积分"
    ></lib>
  </div>
</template>

<script>
import lib from "../../questionlib/index.vue";

export default {
  name: "PracticeQuestionsIndex",
  components: { lib }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/examination-page.scss";
</style>
